// Tension model · shared between VIPExam (60-min module timer) and
// VIPOralExam (30s flash question timer). Sober · medical · premium.
// NO sounds, NO emoji, NO bouncing — only pulse on critical/imminent.

// ─── 30-second flash tension (oral simulator per-question) ───
// Scaled thresholds for a 30s countdown:
//   calm    (≥21s) · neutral amber
//   watch   (11-20s) · amber rim
//   critical (5-10s) · rose + pulse on the ring stroke
//   imminent (<5s)   · deep red + steady pulse
export function flashTensionLevel(secondsLeft) {
  if (secondsLeft >= 21) return { tone: "calm",     pulse: false };
  if (secondsLeft >= 11) return { tone: "watch",    pulse: false };
  if (secondsLeft >= 5)  return { tone: "critical", pulse: true  };
  return                  { tone: "imminent", pulse: true  };
}

// Shared palette — same identity used in the written exam runner so the
// candidate experiences the SAME visual language across both simulators.
export const FLASH_PALETTE = {
  calm:     { stroke: "#7A4F00", trackBg: "rgba(122,79,0,0.15)",   chipBg: "rgba(255,248,231,0.85)", chipFg: "#7A4F00", chipRing: "rgba(122,79,0,0.2)"  },
  watch:    { stroke: "#B45309", trackBg: "rgba(180,83,9,0.18)",   chipBg: "rgba(255,244,214,0.95)", chipFg: "#7A4F00", chipRing: "rgba(180,83,9,0.35)" },
  critical: { stroke: "#9E2A48", trackBg: "rgba(158,42,72,0.18)",  chipBg: "rgba(252,233,238,0.95)", chipFg: "#9E2A48", chipRing: "rgba(158,42,72,0.45)" },
  imminent: { stroke: "#7A1A36", trackBg: "rgba(122,26,54,0.22)",  chipBg: "rgba(254,215,222,0.98)", chipFg: "#7A1A36", chipRing: "rgba(122,26,54,0.6)"  },
};
